// SIMS-6602: this line already has SIMS-8930, which retired getProviderReport,
// so the beneficiary repoint takes the file's last backend-1 call and the v1
// client import goes with it.
import { instanceBo } from "../utils/axios.create";
import {
	beneficiaryReportParams,
	beneficiaryReportResponse,
} from "../domain/report.interface";

const getBeneficiaryReport = async ({
	programId,
	providerSiteId,
	providerId,
	providerNpi,
	beneficiary,
	beneficiaryCin,
	pageNumber,
	pageSize,
	isDownload,
}: beneficiaryReportParams): Promise<{
	data: beneficiaryReportResponse[];
	total: number;
}> => {
	const URLparams = new URLSearchParams();
	if (programId) URLparams.append("programId", programId.join(","));
	if (providerSiteId)
		URLparams.append("providerSiteId", providerSiteId.join(","));
	if (providerId) URLparams.append("providerId", providerId);
	if (providerNpi) URLparams.append("providerNpi", providerNpi);
	if (beneficiary) URLparams.append("beneficiary", beneficiary);
	if (beneficiaryCin) URLparams.append("beneficiaryCin", beneficiaryCin);
	if (pageNumber) URLparams.append("pageNumber", (pageNumber + 1).toString());
	if (pageSize) URLparams.append("pageSize", pageSize.toString());
	if (isDownload) URLparams.append("isDownload", isDownload);

	// SIMS-6602: migrated to backend-2 (`instanceBo`). Same path, same query
	// params, same `{ total, data }` response shape.
	return instanceBo
		.get(`/reports/beneficiary?${URLparams.toString()}`)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

export const reportService = {
	getBeneficiaryReport,
};
